<div #autocompleteAnchor>
  <deprecated-text-field
    #textField
    [name]="name"
    [label]="label"
    [combinedLeft]="combinedLeft"
    [combinedRight]="combinedRight"
    [help]="help"
    [case]="case"
    [disabled]="disabled"
    [error]="error"
    [placeholder]="placeholder"
    [required]="required"
    [warning]="warning"
    [ngModel]="displayText"
    (ngModelChange)="setSearchTerm($event)"
    (focusEvent)="focus()"
  ></deprecated-text-field>
</div>
<ng-container *ngIf="isVisible">
  <deprecated-callout
    *deprecated-callout
    [anchor]="autocompleteAnchor"
    fallbackDirection="cw"
    [preferredPosition]="preferredPosition"
    [allowedPositions]="allowedPositions"
    [scrollable]="false"
    (close)="selectSearchTerm()"
  >
    <div
      class="results rv-card"
      [style.width]="searchOptionWidth"
      [style.max-height.px]="maxHeight"
    >
      <div
        *ngIf="searchTerm != '' && searchTerm != null"
        class="result"
        [class.selected]="isHighlighted('searchTerm')"
        (click)="selectSearchTerm()"
      >
        {{ searchTerm }}
      </div>
      <div
        class="result-group-heading rv-input-label"
        *ngIf="recentMatches.length > 0"
      >
        Recently used
      </div>
      <div
        *ngFor="let option of recentMatches; let i = index; trackBy: trackByFn"
        class="result"
        [class.selected]="isHighlighted('recent', i)"
        (click)="selectOption(option.item)"
      >
        <div class="result-title">
          <fuzzy-highlight
            [text]="option.item.title"
            [indices]="option.titleHighlightIndices"
          ></fuzzy-highlight>
        </div>
        <div class="result-subtitle">
          <fuzzy-highlight
            [text]="option.item.subtitle"
            [indices]="option.subtitleHighlightIndices"
          ></fuzzy-highlight>
        </div>
      </div>
      <ng-container *ngIf="searchTerm != ''">
        <div class="result-group-heading rv-input-label">
          {{ resultLabel }}
        </div>
        <div class="result rv-flex flex-center pad" *ngIf="isSearching">
          <riv-loading></riv-loading>
        </div>
        <ng-container *ngIf="!isSearching">
          <div
            *ngFor="let option of matches; let i = index; trackBy: trackByFn"
            class="result"
            [class.selected]="isHighlighted('results', i)"
            (click)="selectOption(option.item)"
          >
            <div class="result-title">
              <fuzzy-highlight
                [text]="option.item.title"
                [indices]="option.titleHighlightIndices"
              ></fuzzy-highlight>
            </div>
            <div class="result-subtitle">
              <fuzzy-highlight
                [text]="option.item.subtitle"
                [indices]="option.subtitleHighlightIndices"
              ></fuzzy-highlight>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </deprecated-callout>
</ng-container>
